import React from 'react';

import PropTypes from 'prop-types';
import {
    connect,
} from 'react-redux';

import {
    tripSelectors,
} from 'wanderu-ducks-trips';

import EndpointComponent from '../../components/SearchResult/Endpoint/Endpoint';

function Endpoint(props) {
    return (
        <EndpointComponent {...props} />
    );
}

Endpoint.propTypes = {
    className: PropTypes.string,
    type: PropTypes.oneOf([
        'arrive',
        'depart',
    ]).isRequired,
};

function mapStateToProps(state, ownProps) {
    const {
        tripId,
        type,
    } = ownProps;

    const tripData = type === 'arrive'
        ? tripSelectors.selectTripArriveData(state, tripId)
        : tripSelectors.selectTripDepartData(state, tripId);

    return {
        ...tripData,
        numberOfMidnightsPassed: tripSelectors.selectTripNumberOfMidnightsPassed(state, tripId),
    };
}

export {
    Endpoint,
};
export default connect(mapStateToProps)(Endpoint);
